<template>
  <header class="Header">
    <div class="container flex-between" :class="{ 'container-wider': isCartPage || isCheckoutStepRoute }">
      <h1 class="Logo">
        <span>
          <img class="Logo_img" src="@/assets/images/logo.svg" alt="philips">
        </span>
      </h1>
      <div class="flex-between">
        <p class="countryTogger" v-if="isCanadaSite">
          <a @click="changeLanguageToEN" :class="{white: this.$route.query.language === 'en-CA'}">{{ this.$t('common.language.canada.english', 'EN') }}</a>
          <span>|</span>
          <a @click="changeLanguageToFR" :class="{white: this.$route.query.language === 'fr-CA'}">{{ this.$t('common.language.canada.french', 'FR') }}</a>
        </p>
          <p class="countryTogger" v-if="isBelgiumSite">
          <a @click="changeLanguageToNL" :class="{white: this.$route.query.language === 'nl-BE'}">{{ this.$t('common.language.belgium.dutch', 'NL') }}</a>
          <span>|</span>
          <a @click="changeLanguageToBFR" :class="{white: this.$route.query.language === 'fr-BE'}">{{ this.$t('common.language.belgium.french', 'FR') }}</a>
        </p>
        <app-header-menu />
      </div>
    </div>
  </header>
</template>

<script>
  import AppHeaderMenu from 'components/AppHeaderMenu'
  import { detectedCulture } from '@/utilities/common/culture'
  import { loadLolization } from '@/utilities/i18n'
  import { mapGetters } from 'vuex'
  import { pick } from 'lodash'
  import Vue from 'vue'

  export default {
    name: 'app-header',

    data () {
      return {
        canadaLanguage: window.localStorage.getItem('canadaLanguage'),
        belgiumLanguage: window.localStorage.getItem('belgiumLanguage')
      }
    },

    components: {
      AppHeaderMenu
    },

    computed: {
      ...mapGetters('account', ['isAuthenticated']),

      isCartPage () {
        return this.$route.name === 'cart'
      },

      isCheckoutStepRoute () {
        return this.$route.name === 'checkout'
      },

      getBunldeFromQuery () {
        return this.$route.query.bundle
      },

      isCanadaSite () {
        return detectedCulture.code === 'en-ca'
      },

       isBelgiumSite (){ 
        return detectedCulture.code === 'nl-be' 
      }
    },

    methods: {
      canadaChangeLanguageInCheckout (bundle, lanugage) {
        const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: bundle, language: lanugage })
        this.$router.push({
          name: 'checkout',
          query: routeQuery
        })
      },

      canadaChangeLanguageInCart (bundle, lanugage) {
        const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: bundle, language: lanugage })
        this.$router.push({
          name: 'cart',
          query: routeQuery
        })
      },

      //---------Belgium -----------//

       belgiumChangeLanguageInCheckout (bundle, lanugage) {
        const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: bundle, language: lanugage })
        this.$router.push({
          name: 'checkout',
          query: routeQuery
        })
      },

       belgiumChangeLanguageInCart (bundle, lanugage) {
        const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: bundle, language: lanugage })
        this.$router.push({
          name: 'cart',
          query: routeQuery
        })
      },

       //---------End-----------//

      async changeLanguageToEN () {
        if (this.$route.name === 'checkout') {
          this.canadaChangeLanguageInCheckout(this.getBunldeFromQuery, 'en-CA')
        } else {
          const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: 'en-CA' })
          this.$router.push({
            query: routeQuery
          })
        }
        window.localStorage.setItem('canadaLanguage', this.$route.query.language)
        await loadLolization()
        if (this.isAuthenticated) {
          await Vue.api.account.currentLanguage(this.$route.query.language)
        }
        await window.location.reload()
      },

      async changeLanguageToFR () {
        if (this.$route.name === 'checkout') {
          this.canadaChangeLanguageInCheckout(this.getBunldeFromQuery, 'fr-CA')
        } else {
          const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: 'fr-CA' })
          this.$router.push({
            query: routeQuery
          })
        }
        window.localStorage.setItem('canadaLanguage', this.$route.query.language)
        await loadLolization()
        if (this.isAuthenticated) {
          await Vue.api.account.currentLanguage(this.$route.query.language)
        }
        await window.location.reload()
      },

      //---------Belgium -----------//
      async changeLanguageToNL () {
        if (this.$route.name === 'checkout') {
          this.belgiumChangeLanguageInCheckout(this.getBunldeFromQuery, 'nl-BE')
        } else {
          const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: 'nl-BE' })
          this.$router.push({
            query: routeQuery
          })
        }
        window.localStorage.setItem('belgiumLanguage', this.$route.query.language)
        await loadLolization()
        if (this.isAuthenticated) {
          await Vue.api.account.currentLanguage(this.$route.query.language)
        }
        await window.location.reload()
      }, 
      async changeLanguageToBFR () {
        if (this.$route.name === 'checkout') {
          this.belgiumChangeLanguageInCheckout(this.getBunldeFromQuery, 'fr-BE')
        } else {
          const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: 'fr-BE' })
          this.$router.push({
            query: routeQuery
          })
        }
        window.localStorage.setItem('belgiumLanguage', this.$route.query.language)
        await loadLolization()
        if (this.isAuthenticated) {
          await Vue.api.account.currentLanguage(this.$route.query.language)
        }
        await window.location.reload()
      }
      //---------End-----------//
    },
    
    created () {
      if (this.isCanadaSite && this.$route.name !== 'payment-result') {
        if (!this.$route.query.language) {
          if (this.canadaLanguage) {
            if (this.$route.name === 'cart') {
              this.canadaChangeLanguageInCart(this.getBunldeFromQuery, this.canadaLanguage)
            } else if (this.$route.name === 'checkout') {
              this.canadaChangeLanguageInCheckout(this.getBunldeFromQuery, this.canadaLanguage)
            } else {
              this.$router.push({
                query: {
                  language: this.canadaLanguage
                }
              })
            }
            window.localStorage.setItem('canadaLanguage', this.canadaLanguage)
          } else {
            if (this.$route.name === 'cart') {
              this.canadaChangeLanguageInCart(this.getBunldeFromQuery, 'en-CA')
            } else if (this.$route.name === 'checkout') {
              this.canadaChangeLanguageInCheckout(this.getBunldeFromQuery, 'en-CA')
            } else {
              this.$router.push({
                query: {
                  language: 'en-CA'
                }
              })
            }
            window.localStorage.setItem('canadaLanguage', this.$route.query.language)
          }
        } else if (this.$route.query.language) {
          if (this.$route.name === 'cart') {
            this.canadaChangeLanguageInCart(this.getBunldeFromQuery, this.$route.query.language)
          } else if (this.$route.name === 'checkout') {
            this.canadaChangeLanguageInCheckout(this.getBunldeFromQuery, this.$route.query.language)
          } else {
            this.$router.push({
              query: {
                language: this.$route.query.language
              }
            })
          }
          window.localStorage.setItem('canadaLanguage', this.$route.query.language)
        }
      }
      if (detectedCulture.code !== 'en-ca') {
        window.localStorage.removeItem('canadaLanguage')
      }

       //---------Belgium-------//
      if (this.isBelgiumSite && this.$route.name !== 'payment-result') {
        if (!this.$route.query.language) {
          if (this.belgiumLanguage) {
            if (this.$route.name === 'cart') {
              this.belgiumChangeLanguageInCart(this.getBunldeFromQuery, this.belgiumLanguage)
            } else if (this.$route.name === 'checkout') {
              this.belgiumChangeLanguageInCheckout(this.getBunldeFromQuery, this.belgiumLanguage)
            } else {
              this.$router.push({
                query: {
                  language: this.belgiumLanguage
                }
              })
            }
            window.localStorage.setItem('belgiumLanguage', this.belgiumLanguage)
          } else {
            if (this.$route.name === 'cart') {
              this.belgiumChangeLanguageInCart(this.getBunldeFromQuery, 'nl-BE')
            } else if (this.$route.name === 'checkout') {
              this.belgiumChangeLanguageInCheckout(this.getBunldeFromQuery, 'nl-BE')
            } else {
              this.$router.push({
                query: {
                  language: 'nl-BE'
                }
              })
            }
            window.localStorage.setItem('belgiumLanguage', this.$route.query.language)
          }
        } else if (this.$route.query.language) {
          if (this.$route.name === 'cart') {
            this.belgiumChangeLanguageInCart(this.getBunldeFromQuery, this.$route.query.language)
          } else if (this.$route.name === 'checkout') {
            this.belgiumChangeLanguageInCheckout(this.getBunldeFromQuery, this.$route.query.language)
          } else {
            this.$router.push({
              query: {
                language: this.$route.query.language
              }
            })
          }
          window.localStorage.setItem('belgiumLanguage', this.$route.query.language)
        }
      }
      if (detectedCulture.code !== 'nl-be') {
        window.localStorage.removeItem('belgiumLanguage')
      } 
      //---------End-----------//
    }
  }
</script>

<style lang="scss">
  .Header {
    height: .48rem;
    background: #1474a4;

    .Logo {
      display: inline-flex;
      position: relative;
      background: #fff;
      border-bottom-right-radius: .15rem;

      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: .28rem;
        background-image: linear-gradient(to right, #1d4c84 0, #1474a4 100%);
        z-index: -1;
        bottom: -.08rem;
        left: 0;
      }

      span {
        width: .95rem;
        height: .44rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      &_img {
        width: .79rem;
        height: auto;
      }
    }

    .countryTogger {
      color: white;
      margin-right: .4rem;

      span {
        margin: 0 .05rem;
      }

      a:hover {
        font-weight: bold;
      }

      .white {
        font-weight: bold;
      }
    }
  }
</style>
